export function isRegularNumber(o?: any): o is number {
    return typeof o === 'number'
        && !isNaN(o)
        && isFinite(o);
}
